import { render, staticRenderFns } from "./normal_thankyou.vue?vue&type=template&id=65f1684a&scoped=true"
import script from "./normal_thankyou.vue?vue&type=script&lang=js"
export * from "./normal_thankyou.vue?vue&type=script&lang=js"
import style0 from "./normal_thankyou.vue?vue&type=style&index=0&id=65f1684a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1684a",
  null
  
)

export default component.exports